import { Box, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Button } from '@efexteam/components';
import { ContactConfirmation } from '../../../../assets';

interface IConfirmation {
  email: string;
  onClose: () => void;
}

const Confirmation = ({ email, onClose }: IConfirmation) => {
  const { t } = useTranslation();
  return (
    <>
      <Grid rowSpacing={2} columnSpacing={{ xs: 2, sm: 2, md: 3 }}>
        <Grid item xs={12}>
          <img
            src={ContactConfirmation}
            alt="contact confirmation"
            className="max-w-[150px] mb-5 mx-auto"
          />
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6" className="text-center">
          {t('ccConfirmationTitle')}
        </Typography>
        <Typography variant="body2" className="text-center !my-2">
          <b>{email}</b> {t('ccConfirmationMessage')}
        </Typography>
        <Box className="flex justify-center">
          <Button
            appearance="primary"
            size="large"
            className="mt-5 mx-auto block"
            onClick={onClose}
          >
            {t('close')}
          </Button>
        </Box>
      </Grid>
    </>
  );
};

export default Confirmation;
